import { render, staticRenderFns } from "./pages.vue?vue&type=template&id=53b72fc3&scoped=true&"
import script from "./pages.vue?vue&type=script&lang=js&"
export * from "./pages.vue?vue&type=script&lang=js&"
import style0 from "./pages.vue?vue&type=style&index=0&id=53b72fc3&lang=scss&scoped=true&"
import style1 from "./pages.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b72fc3",
  null
  
)

export default component.exports